import React from 'react';

function Share(props) {
  return (
    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" {...props}>
      <path
        d="M13.4525 10.5372V8.93617C13.4525 7.50416 10.8331 6.69922 9.50779 6.69922C8.18252 6.69922 5.56311 7.50416 5.56311 8.93617V10.5372H13.4525Z"
        stroke="#3E3E40"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M2.75208 3.15869V6.64975"
        stroke="#3E3E40"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M4.50452 4.90674H1.00012"
        stroke="#3E3E40"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M9.50783 5.12019C10.5959 5.12019 11.4779 4.24213 11.4779 3.15897C11.4779 2.07582 10.5959 1.19775 9.50783 1.19775C8.41977 1.19775 7.53772 2.07582 7.53772 3.15897C7.53772 4.24213 8.41977 5.12019 9.50783 5.12019Z"
        stroke="#3E3E40"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Share;
